import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    gap: 'var(--ui-spacer-s)',
  },
  option: {
    appearance: 'none',
    border: 'none',
    background: 'none',
    // padding: 0,
    margin: 0,
    cursor: 'pointer',
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.6,
    },
    backgroundColor: 'var(--ui-tag-selector-group-option-background-color)',
    minHeight: '4.4rem',
    padding: '0.8rem',
    paddingLeft: '1.6rem',
    paddingRight: '1.6rem',
    borderRadius: '2.2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1.2rem',
    color: 'var(--ui-tag-selector-group-option-color)',
    // '&:hover': {
    //   backgroundColor: theme.colors.gray200,
    // },
    // '&:focus': {
    //   outline: 'none',
    // },
  },
  optionActive: {
    backgroundColor: 'var(--ui-tag-selector-group-option-active-background-color)',
    color: 'var(--ui-tag-selector-group-option-active-color)',
  },
  count: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minWidth: '2.8rem',
    height: '2.8rem',
    padding: '0.8rem',
    marginRight: '-0.8rem',
    borderRadius: '1.4rem',
    backgroundColor: 'var(--ui-tag-selector-group-option-count-background-color)',
    color: 'var(--ui-tag-selector-group-option-count-color)',
  },
  countActive: {
    backgroundColor: 'var(--ui-tag-selector-group-option-active-count-background-color)',
    color: 'var(--ui-tag-selector-group-option-active-count-color)',
  },
}))

export default useStyles
